<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>لیست بلاگ ها</h1>
          <b-table
            class="position-relative"
            :items="blogsList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(actions)="data">
              <div class="d-flex align-items-center" style="gap: 1rem">
                <b-link :to="`/blogs/${data.item.id}`">
                  <feather-icon
                    size="20"
                    icon="EditIcon"
                    style="cursor: pointer"
                    class="text-primary"
                  />
                </b-link>
                <span
                  class="cursor-pointer"
                  @click="renderDeleteModal(data.item.id)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="20"
                    class="text-danger"
                  />
                </span>
              </div>
            </template>
            <template #cell(status)="data">
              {{ blogStatuses[data.item.status] }}
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
      <b-modal
        title="حذف بلاگ"
        id="modal-delete"
        centered
        ok-title="بله"
        cancelTitle="خیر"
        @ok="sendBlogDeleteRequest"
      >
        <span>آیا از حذف کردن این بلاگ اطمینان دارید ؟ </span>
      </b-modal>
    </b-row>
  </b-overlay>
</template>

<script>
import {DeleteABlog, GetAllBlogs} from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRow,
  BFormTextarea,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from "bootstrap-vue";

export default {
  mounted() {
    this.getAllBlogsList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllBlogsList();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      categoryName: null,
      tagId: null,
      searchByTitle: null,
      date: null,
      blogsList: null,
      blogStatuses: {
        'Publish': "منتشر شده",
        'PreRelease': "آرشیو",
      },
      myTableColumns: [
        {
          key: "id",
          label: "شناسه بلاگ",
        },
        {
          key: "title",
          label: "عنوان بلاگ",
        },
        {
          key: "status",
          label: "وضعیت",
        },

        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempBlogId: null,
    };
  },
  methods: {
    async sendBlogDeleteRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteABlog = new DeleteABlog(_this);
        deleteABlog.setRequestParam({id: _this.tempBlogId,secretKey:_this.fermanSecretKey});
        await deleteABlog.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بلاگ با موفقیت حذف شد",
                icon: "Trash2Icon",
                variant: "success",
              },
            });
            _this.getAllBlogsList();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderDeleteModal(blogId) {
      this.tempBlogId = blogId;
      this.$bvModal.show("modal-delete");
    },
    async getAllBlogsList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllBlogs = new GetAllBlogs(_this);
        let qParams = {
          count: _this.count,
          pageNumber: _this.pageNumber,
        };
        getAllBlogs.setRequestParam(qParams);
        await getAllBlogs.fetch((response) => {
          if (response.isSuccess) {
            _this.blogsList = response.data.data;
            _this.totalCount = response.data.totalCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed:{
    fermanSecretKey() {
      return process.env.VUE_APP_BLOG_SECRET
    },
  },
  components: {
    BFormRow,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
